import React, { Component } from 'react';

function getStatusText(status) {
    if (status === 1) return "Active";
    return "Disconnected";
}

export function ConnectedUserList(props) {
    return (
        <div>
            <h4>Connected players</h4>
            <ul>
                {props.users?.map(u => <li key={u.username + u.status + u.team}>{u.username + ' - Team ' + u.team + ' (' + getStatusText(u.status) + ')'}</li>)}
            </ul>
        </div>
    );
}
